<div class="grid">
  <!-- Left Card: Equipment Tables with Tabs -->
  <div class="col-8" style="height: calc(100vh - 100px);">
    <p-card class="h-full">
      <p-tabView styleClass="equipment-tabs h-full">
        <!-- Trucks Tab -->
        <p-tabPanel header="Trucks">
          <div class="table-header flex justify-content-between align-items-center p-3">
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-truck text-primary text-xl"></i>
              <span class="text-xl font-semibold">Trucks</span>
              <p-badge [value]="trucks.length.toString()" severity="primary"></p-badge>
            </div>
            <div class="flex gap-2 align-items-center">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="truckSearchTerm" (input)="filterTrucks()"
                  placeholder="Search Trucks" class="p-inputtext-sm" />
              </span>
              <p-button *ngIf="isAdmin" icon="pi pi-plus" label="Add Truck" size="small" text="true"
                (click)="openNewTruckDialog()"></p-button>
            </div>
          </div>
          <p-table [value]="filteredTrucks" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="600px"
            [rowHover]="true" dataKey="truck_id" responsiveLayout="scroll" [sortField]="'truck_number'" [sortOrder]="1" [customSort]="true" (sortFunction)="customSort('truck_number', $event)">
            <ng-template pTemplate="header">
              <tr>
                <th class="text-primary">Truck #</th>
                <th class="text-primary">Driver</th>
                <th class="text-primary">Parked</th>
                <th class="text-primary">Status</th>
                <th style="width: 100px"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-truck>
              <tr>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-truck text-primary"></i>
                    <span class="font-medium">{{truck.truck_number}}</span>
                  </div>
                </td>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-user text-primary"></i>
                    <span>{{truck.driver_name || ''}}</span>
                  </div>
                </td>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-map-marker text-primary"></i>
                    <span>{{ truck.location_name }}</span>
                  </div>
                </td>
                <td>
                  <p-chip *ngIf="truck.status" [label]="truck.status"></p-chip>
                </td>
                
                <td>
                  <div class="flex align-items-center justify-content-center gap-2">
                    <button *ngIf="hasAccess" pButton pRipple type="button" icon="pi pi-pencil"
                      (click)="onRowEditInit(truck)" class="p-button-rounded p-button-text"></button>
                    <button *ngIf="isAdmin" pButton pRipple type="button" icon="pi pi-trash"
                      (click)="deleteTruck(truck)" class="p-button-rounded p-button-text p-button-danger"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>

        <!-- Trailers Tab -->
        <p-tabPanel header="Trailers">
          <div class="table-header flex justify-content-between align-items-center p-3">
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-box text-primary text-xl"></i>
              <span class="text-xl font-semibold">Trailers</span>
              <p-badge [value]="trailers.length.toString()" severity="primary"></p-badge>
            </div>
            <div class="flex gap-2 align-items-center">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="trailerSearchTerm" (input)="filterTrailers()"
                  placeholder="Search Trailers" class="p-inputtext-sm" />
              </span>
              <p-button *ngIf="isAdmin" icon="pi pi-plus" label="Add Trailer" size="small" text="true"
                (click)="openNewTrailerDialog()"></p-button>
            </div>
          </div>
          <p-table [value]="filteredTrailers" styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="600px"
            [rowHover]="true" dataKey="trailer_id" responsiveLayout="scroll" [sortField]="'trailer_number'" 
            [customSort]="true" (sortFunction)="customSort('trailer_number', $event)">
            <ng-template pTemplate="header">
              <tr>
                <th class="text-primary">Trailer #</th>
                <th class="text-primary">Setup</th>
                <th class="text-primary">Location</th>
                <th class="text-primary">Status</th>
                <th style="width: 100px"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-trailer>
              <tr>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-box text-primary"></i>
                    <span class="font-medium">{{trailer.trailer_number}}</span>
                  </div>
                </td>
                <td>{{trailer.setup}}</td>
                <td>
                  <div class="flex align-items-center gap-2">
                    <i class="pi pi-map-marker text-primary"></i>
                    <span>{{ trailer.location_name }}</span>
                  </div>
                </td>
                <td>
                  <p-chip *ngIf="trailer.status" [label]="trailer.status"></p-chip>
                </td>
                <td>
                  <div class="flex align-items-center justify-content-center gap-2">
                    <button *ngIf="hasAccess" pButton pRipple type="button" icon="pi pi-pencil"
                      (click)="onRowEditInit(trailer)" class="p-button-rounded p-button-text"></button>
                    <button *ngIf="isAdmin" pButton pRipple type="button" icon="pi pi-trash"
                      (click)="deleteTrailer(trailer)" class="p-button-rounded p-button-text p-button-danger"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>
      </p-tabView>
    </p-card>
  </div>

  <!-- Right Card: Van Trailers by Location -->
  <div class="col-4" style="height: calc(100vh - 100px);">
    <p-card class="h-full">
      <div class="flex justify-content-between align-items-center p-3">
        <div class="flex gap-2 align-items-center">
          <i class="pi pi-truck text-primary text-xl"></i>
          <span class="text-xl font-semibold">Van Trailers</span>
          <p-badge [value]="totalVanTrailers" severity="primary"></p-badge>
        </div>
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText type="text" [(ngModel)]="vanTrailerSearchTerm" (input)="filterVanTrailers()"
            placeholder="Search Van Trailers" class="p-inputtext-sm" />
        </span>
      </div>

      <div class="location-groups p-3" style="height: calc(100% - 70px); overflow-y: auto;">
        <div *ngFor="let location of vanLocations" class="location-group mb-4">
          <div class="location-header flex align-items-center mb-3">
            <i class="pi pi-map-marker text-primary mr-2"></i>
            <span class="text-800 font-medium text-lg">{{location.location_name}}</span>
            <span class="text-500 ml-2 text-sm" *ngIf="getVansAtLocation(location).length > 0">
              {{getVansAtLocation(location).length}} trailers
            </span>
          </div>

          <div *ngIf="getVansAtLocation(location).length === 0" class="text-500 text-sm pl-4 pb-2">
            No trailers at this location
          </div>

          <div class="location-items pl-4" *ngIf="getFilteredVansAtLocation(location).length > 0">
            <div *ngFor="let van of getFilteredVansAtLocation(location)"
              class="van-item flex align-items-center justify-content-between p-3 mb-2 surface-card border-round-lg shadow-2 hover:shadow-3 transition-all transition-duration-200">
              <div class="flex align-items-center">
                <i class="pi pi-truck text-primary mr-3"></i>
                <span class="font-medium text-800">{{van.trailer_number}}</span>
                
                <!-- Clickable status indicators -->
                <span *ngIf="van.status === 'Loaded' || !van.status || van.status === 'Empty'" 
                      class="ml-3 px-2 py-1 border-round cursor-pointer flex align-items-center"
                      [ngClass]="{
                        'bg-yellow-100 text-yellow-800': van.status === 'Loaded',
                        'bg-green-100 text-green-800': van.status === 'Empty' || !van.status
                      }"
                      style="font-size: 0.75rem; font-weight: 600;"
                      (click)="toggleVanStatus(van)">
                  <span class="mr-1" style="display: inline-block; width: 0.7rem; height: 0.7rem; border-radius: 50%; background-color: currentColor;" *ngIf="van.status === 'Empty'"></span>
                  <i class="pi pi-check-circle mr-1" style="font-size: 0.7rem;" *ngIf="van.status === 'Loaded'"></i>
                  <span>{{ van.status === 'Loaded' ? 'Loaded' : 'Empty' }}</span>
                </span>
                
                <!-- For other statuses like Maintenance or OOS (not clickable) -->
                <span *ngIf="van.status && van.status !== 'Loaded' && van.status !== 'Empty'" 
                      class="ml-3 px-2 py-1 border-round bg-bluegray-50 text-bluegray-800 flex align-items-center"
                      style="font-size: 0.75rem; font-weight: 600;">
                  <i class="pi pi-info-circle mr-1" style="font-size: 0.7rem;"></i>
                  {{van.status}}
                </span>
              </div>
              <div *ngIf="hasAccess" class="flex align-items-center">
                <p-dropdown [options]="vanLocations" 
                  [(ngModel)]="van.location_id" 
                  optionLabel="location_name"
                  optionValue="location_id" 
                  (onChange)="updateVanLocation(van, $event)"
                  styleClass="p-button-text p-button-rounded small-dropdown" 
                  [showClear]="false" 
                  appendTo="body">
                  <ng-template pTemplate="selectedItem" let-location>
                    <span class="text-sm">{{location?.location_name || 'Select Location'}}</span>
                  </ng-template>
                  <ng-template pTemplate="item" let-location>
                    <span class="text-sm">{{location.location_name}}</span>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<p-dialog class="new-truck-dialog" [(visible)]="newTruckDialog" 
  [style]="{width: '500px'}" 
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="p-fluid customer-style-dialog">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="text-xl font-semibold">Add New Truck</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="p-fluid">
      <div class="field mb-4">
        <label for="truckNumber" class="block text-900 font-medium mb-2">Truck Number</label>
        <input pInputText id="truckNumber" [(ngModel)]="truckForm.value.truck_number" class="w-full" />
      </div>
      <div class="field mb-4">
        <label for="location" class="block text-900 font-medium mb-2">Location</label>
        <p-dropdown id="location" [options]="getLocationOptionsForTruck()" [(ngModel)]="truckForm.value.location_id"
          optionLabel="location_name" optionValue="location_id" 
          styleClass="w-full"
          appendTo="body"></p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton pRipple label="Cancel" icon="pi pi-times" 
        class="p-button-outlined" (click)="hideDialog()"></button>
      <button pButton pRipple label="Save" icon="pi pi-check" 
        class="p-button-primary" (click)="saveTruck()"
        [disabled]="savingTruck"
        [loading]="savingTruck"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog class="new-trailer-dialog" [(visible)]="newTrailerDialog" 
  [style]="{width: '500px'}" 
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="p-fluid customer-style-dialog">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="text-xl font-semibold">Add New Trailer</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="p-fluid">
      <div class="field mb-4">
        <label for="trailerNumber" class="block text-900 font-medium mb-2">Trailer Number</label>
        <input pInputText id="trailerNumber" [(ngModel)]="trailerForm.value.trailer_number" class="w-full" />
      </div>
      <div class="field mb-4">
        <label for="setup" class="block text-900 font-medium mb-2">Setup Type</label>
        <p-dropdown id="setup" 
          [options]="setupTypes" 
          [(ngModel)]="trailerForm.value.setup"
          placeholder="Select Setup Type"
          styleClass="w-full"
          appendTo="body">
        </p-dropdown>
      </div>
      <div class="field mb-4">
        <label for="trailerLocation" class="block text-900 font-medium mb-2">Location</label>
        <p-dropdown id="trailerLocation" 
          [options]="getLocationOptionsForTrailerForm()" 
          [ngModel]="getTrailerFormLocationValue()"
          (ngModelChange)="setTrailerFormLocationValue($event)"
          optionLabel="location_name" 
          optionValue="location_id"
          styleClass="w-full"
          appendTo="body"></p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton pRipple label="Cancel" icon="pi pi-times" 
        class="p-button-outlined" (click)="hideDialog()"></button>
      <button pButton pRipple label="Save" icon="pi pi-check" 
        class="p-button-primary" (click)="saveTrailer()"
        [disabled]="savingTrailer"
        [loading]="savingTrailer"></button>
    </div>
  </ng-template>
</p-dialog>


<!-- Edit Truck Dialog -->
<p-dialog class="edit-truck-dialog" [(visible)]="editTruckDialog" 
  [style]="{width: '500px'}" 
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="p-fluid customer-style-dialog">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="text-xl font-semibold">Edit Truck {{selectedTruck.truck_number}}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="p-fluid">
      <div class="field mb-4">
        <label for="email" class="block text-900 font-medium mb-2">Email</label>
        <span class="p-input-icon-left w-full">
          <i class="pi pi-envelope"></i>
          <input pInputText id="email" [(ngModel)]="selectedTruck.email" class="w-full" />
        </span>
      </div>
      <div class="field mb-4">
        <label for="location" class="block text-900 font-medium mb-2">Location</label>
        <p-dropdown id="location" [options]="getLocationOptionsForTruck()" [(ngModel)]="selectedTruck.location_id"
          [placeholder]="selectedTruck.location_name"
          [optionLabel]="isTruck(selectedTruck) ? 'location_name' : 'name'" 
          [optionValue]="isTruck(selectedTruck) ? 'location_id' : 'customer_id'" 
          styleClass="w-full"
          appendTo="body"></p-dropdown>
      </div>
      <div class="field mb-4">
        <label for="status" class="block text-900 font-medium mb-2">Status</label>
        <p-dropdown id="status" [options]="statusOptions" [(ngModel)]="selectedTruck.status"
          [placeholder]="selectedTruck.status"
          optionLabel="name" optionValue="status" 
          styleClass="w-full"
          appendTo="body"></p-dropdown>
      </div>

    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton pRipple label="Cancel" icon="pi pi-times" 
        class="p-button-outlined" (click)="hideDialog()"></button>
      <button pButton pRipple label="Save" icon="pi pi-check" 
        class="p-button-primary" (click)="onRowEditSave(selectedTruck)"></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog class="edit-trailer-dialog" [(visible)]="editTrailerDialog" 
  [style]="{width: '500px'}" 
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="p-fluid customer-style-dialog">
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <span class="text-xl font-semibold">Edit Trailer {{selectedTrailer.trailer_number}}</span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="p-fluid">
      <div class="field mb-4">
        <label for="setup" class="block text-900 font-medium mb-2">Setup Type</label>
        <p-dropdown id="setup" 
          [options]="setupTypes" 
          [(ngModel)]="selectedTrailer.setup"
          [placeholder]="selectedTrailer.setup"
          styleClass="w-full"
          appendTo="body">
        </p-dropdown>
      </div>
      <div class="field mb-4">
        <label for="location" class="block text-900 font-medium mb-2">Location</label>
        <p-dropdown id="location" 
          [options]="getLocationOptionsForTrailer(selectedTrailer)" 
          [ngModel]="getSelectedTrailerLocationValue()"
          (ngModelChange)="setSelectedTrailerLocationValue($event)"
          [placeholder]="selectedTrailer.location_name"
          optionLabel="location_name" 
          optionValue="location_id"
          styleClass="w-full"
          appendTo="body"></p-dropdown>
      </div>
      <div class="field mb-4">
        <label for="status" class="block text-900 font-medium mb-2">Status</label>
        <p-dropdown id="status" [options]="statusOptions" [(ngModel)]="selectedTrailer.status"
          [placeholder]="selectedTrailer.status"
          optionLabel="name" optionValue="status" 
          styleClass="w-full"
          appendTo="body"></p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button pButton pRipple label="Cancel" icon="pi pi-times" 
        class="p-button-outlined" (click)="hideDialog()"></button>
      <button pButton pRipple label="Save" icon="pi pi-check" 
        class="p-button-primary" (click)="onRowEditSave(selectedTrailer)"></button>
    </div>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>